<template>
  <b-alert v-if="showAlert" show variant="warning" class="mb-3" dismissible>
    <i class="bx bx-error-circle mr-1"></i>
    <strong>Atenção:</strong> {{ message }}
    <router-link v-if="formLink" :to="formLink" class="alert-link ml-1">
      Ir para o Formulário
    </router-link>
  </b-alert>
</template>

<script>
import http from '@/http'

export default {
  name: 'FeatureFieldAlert',
  props: {
    // Nome do campo requerido (cpf, phone, gender, badge_name)
    requiredField: {
      type: String,
      required: true
    },
    // Mensagem customizada (opcional)
    customMessage: {
      type: String,
      default: null
    },
    // Condição extra para mostrar (ex: só mostrar se feature está ativa)
    condition: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      fieldExists: true,
      loaded: false
    }
  },
  computed: {
    showAlert () {
      return this.loaded && !this.fieldExists && this.condition
    },
    message () {
      if (this.customMessage) return this.customMessage

      const messages = {
        cpf: 'O campo CPF não foi encontrado no formulário de inscrição. Adicione-o no Construtor de Formulário para utilizar esta funcionalidade.',
        phone: 'O campo Telefone não foi encontrado no formulário de inscrição. Adicione-o no Construtor de Formulário para enviar mensagens via WhatsApp.',
        gender: 'O campo Gênero não foi encontrado no formulário de inscrição. Adicione-o no Construtor de Formulário para utilizar a gestão de hospedagem com separação por gênero.',
        badge_name: 'O campo Nome para Crachá não foi encontrado no formulário de inscrição. Adicione-o no Construtor de Formulário para personalizar as etiquetas.'
      }
      return messages[this.requiredField] || `O campo "${this.requiredField}" não foi encontrado no formulário.`
    },
    formLink () {
      return '/form-builder'
    }
  },
  mounted () {
    this.checkField()
  },
  methods: {
    async checkField () {
      try {
        const { data } = await http.get('/admin/forms/field-check')
        this.fieldExists = data.data[this.requiredField] || false
      } catch (e) {
        // Em caso de erro, não mostra o alert
        this.fieldExists = true
      }
      this.loaded = true
    }
  }
}
</script>
